(function() { window.GUID_76666c53_42dd_411e_b79d_e8ee6ff03511 = { getGuid: function() { return "76666c53-42dd-411e-b79d-e8ee6ff03511"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let EventsLinkerActionType;
        (function (EventsLinkerActionType) {
            EventsLinkerActionType[EventsLinkerActionType["Link"] = 1] = "Link";
            EventsLinkerActionType[EventsLinkerActionType["Unlink"] = 2] = "Unlink";
            EventsLinkerActionType[EventsLinkerActionType["Follow"] = 3] = "Follow";
            EventsLinkerActionType[EventsLinkerActionType["Unfollow"] = 4] = "Unfollow";
        })(EventsLinkerActionType = Enumeration.EventsLinkerActionType || (Enumeration.EventsLinkerActionType = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=EventsLinkerActionType.pre.js.map
